module.exports = __webpack_public_path__ + "img/removeMax.4eaae303.png";